<template>
    <card title="Expired on Order">
        <div>
            <b-row>
                <b-col>
                    <SearchComponent v-model="storeFilter" label="Store" search-u-r-l="/Store" :params="{active: true}" :prepopulate="true"
                        :clearable="true" @input="search" />
                </b-col>
            </b-row>
        </div>
        <PrescriptionsListComponent :busy="loading" :prescriptions="pagedPrescriptions"
            :showGeneralActionButtons="false" :showSelectCheckox="false" :actionButtons="['edit']" always-show-void
            :manual-sort="['fillDate', 'productNameShort', 'programName']" :default-sort="sortBy"
            @sort-changed="handleSort" />
        <BottomPagerBar v-model="pageNumber" show-total show-page-size-selector :total-rows="prescriptions.length"
            :per-page="pageSize" item-name="prescription" :loading="loading" @change-page-size="pageSize = $event" />
    </card>
</template>

<script lang="ts">
import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator';
import Axios from 'axios';

import { Prescription } from '@/models/Prescription';
import { Store } from '@/models/Store';

import SearchComponent from '@/components/SearchComponent.vue';
import PrescriptionsListComponent from '@/components/Prescription/PrescriptionsListComponent.vue';
import BottomPagerBar from '@/components/BottomPagerBar.vue';
import { NotificationOptions } from '@/util/NotificationOptionsPresets';
import { getPageSizePreference, savePageSizePreference } from '@/util/pageSizePreference';

@Component({
    name: "ExpiredOnOrderPage",
    components: {
        SearchComponent,
        PrescriptionsListComponent,
        BottomPagerBar
    },
})
export default class ExpiredOnOrderPage extends Vue {
    private prescriptions: Array<Prescription> = [];
    private storeFilter: Store = new Store();
    private loading: boolean = false;
    private pageNumber = 1;
    private pageSize = 25;

    private sortBy: string = "fillDate";
    private sortDirection: string = "D";

    created() {
        this.pageSize = getPageSizePreference(this, 'pageSize_ExpiredOnOrder', 25);
        this.search();
    }

    async search() {
        try {
            this.loading = true;
            const response = await Axios.get(`/Prescription/ExpiredOnOrder/${this.storeFilter?.id || ''}`);
            this.prescriptions = response.data;
        }
        catch (error) {
            console.warn("Error while fetching prescriptions", error);
            this.$notification(NotificationOptions.error(error));
        }
        finally {
            this.loading = false;
        }
    }

    get sortedPrescriptions() {
        let sorted = [...this.prescriptions];

        switch (this.sortBy) {
            case "productNameShort":
                sorted.sort((a, b) => a.productNameShort?.localeCompare(b.productNameShort));
                break;
            case "programName":
                sorted.sort((a, b) => a.programName?.trim().localeCompare(b.programName?.trim()));
                break;
            default:
                sorted.sort((a, b) => new Date(a.fillDate).getTime() - new Date(b.fillDate).getTime());
                break;
        }

        if (this.sortDirection === "D") sorted.reverse();

        return sorted;
    }

    get pagedPrescriptions() {
        const startIndex = this.pageSize * this.pageNumber - this.pageSize;
        const endIndex = startIndex + this.pageSize;
        return this.sortedPrescriptions.slice(startIndex, endIndex);
    }

    @Watch("prescriptions")
    @Watch("pageSize")
    resetPageNumber() {
        this.pageNumber = 1;
    }

    @Watch("pageSize")
    onPageSizePreferenceChanged() {
        savePageSizePreference(this, 'pageSize_ExpiredOnOrder', this.pageSize);
    }

    handleSort(event: any) {
        this.sortBy = event.sortBy;
        this.sortDirection = event.sortDesc ? "D" : "A";
        this.pageNumber = 1;
    }
}

</script>
